import React from 'react'
import LogoUsageComponent from '../../components/marketingGuidelines/marketingComponents/LogoUsage/LogoUsageComponent'
import { Col } from 'react-bootstrap';
import './logoUsageLayout.scss'

class LogoUsageLayout extends React.Component {
    render() {
        return <div className="logousage-layout">
            <div className="warning-section">
                <Col xs={1} align="center">
                    <span className='icon-warning-grey' />
                </Col>
                <p>Use of the Life Fitness logo requires the expressed written consent from Life Fitness. Contact <a href="mailto:developers@lifefitness.com">developers@lifefitness.com</a> for information.</p>
            </div>
            <br />
            <h2>Logo Usage</h2>
            <LogoUsageComponent />
        </div>
    }
}

export default LogoUsageLayout



// WEBPACK FOOTER //
// ./src/layouts/LogoUsage/LogoUsageLayout.js